import { FormDefinition } from '@lbmx/per-form';

export const schemaDefinition = (fields: any): FormDefinition<any> => ({
  fields,
});
